import useOneTimePasswordForm from "./UseOneTimePasswordForm";

import Input from "../../../inputs/Input";
import PrimaryButton from "../../../buttons/PrimaryButton";
import SecondaryButton from "../../../buttons/SecondaryButton";

import style from '../LoginForms.module.css';

const OneTimePasswordForm = ({ submitButtonText = 'Continue', secondaryButtonText = 'Back', verticalButtons = false,
  onSubmitFormCallback, onSecondaryButtonClicked }) => {
  const {
    formState,
    errorState,
    handleSubmit,
    onValueChanged
  } = useOneTimePasswordForm(onSubmitFormCallback);

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12">
          <Input
            label={'One Time Code*'}
            name={'oneTimePassword'}
            value={formState.oneTimePassword}
            error={errorState.oneTimePassword}
            message={errorState.oneTimePassword}
            onChange={(value) => onValueChanged('One Time Code', 'oneTimePassword', value)} />
        </div>
        <div className={["col-xs-12 usas-extra-top-margin", style.FormButtons, verticalButtons ? style.Vertical : ''].join(' ')}>
          <PrimaryButton type="submit">{submitButtonText}</PrimaryButton>
          <SecondaryButton type="button" onClick={onSecondaryButtonClicked}>{secondaryButtonText}</SecondaryButton>
        </div>
      </div>
    </form>
  );
};

export default OneTimePasswordForm;